import { IOrderItem, IDiscountItemMap, TOrderPlatform } from '../../model/order.store'
import { getItemSoldPrice } from '../order.util'
import { includes, some, forEach } from 'lodash'
import { isAfter } from 'date-fns'

/**
 * Chương trình "Giảm giá Combo 2 bánh Bắc Nam một nhà"
 * Cứ 2 bánh trong list SKUs chỉ định thì giảm còn 100k/bánh (thay vì 120k)
 * Áp dụng từ 7/4/2026
 */

const PROMOTION_NAME = 'Giảm giá Combo 2 bánh "Bắc Nam một nhà"'
const COMBO_PRICE = 200000
const COMBO_SIZE = 2
const PROMOTION_START = new Date('2026-04-04T00:00:00+07:00')

const COMBO_SKUS = ['V10823', 'V10824', 'V10825', 'V10826']

interface IProcessComboBacNamMotNhaParams {
  items: IOrderItem[]
  resultMap: IDiscountItemMap
  orderPlatform: TOrderPlatform
  orderType: string
}

export function processComboBacNamMotNha({
  items,
  resultMap,
  orderPlatform,
  orderType
}: IProcessComboBacNamMotNhaParams): void {
  if (!isAfter(new Date(), PROMOTION_START)) {
    return
  }

  if (!some(items, item => includes(COMBO_SKUS, item.sku))) {
    return
  }

  let totalComboQuantity = 0
  forEach(items, item => {
    if (includes(COMBO_SKUS, item.sku)) {
      totalComboQuantity += item.quantity
    }
  })

  const numberOfCombos = Math.floor(totalComboQuantity / COMBO_SIZE)
  if (numberOfCombos <= 0) {
    return
  }

  let remainingDiscountQuantity = numberOfCombos * COMBO_SIZE
  const pricePerUnit = COMBO_PRICE / COMBO_SIZE

  forEach(items, item => {
    if (!includes(COMBO_SKUS, item.sku) || remainingDiscountQuantity <= 0) {
      return
    }

    const soldPrice = getItemSoldPrice({
      item,
      orderPlatform,
      orderType
    })

    const discountQuantity = Math.min(item.quantity, remainingDiscountQuantity)
    const discountPerUnit = soldPrice - pricePerUnit

    if (discountPerUnit > 0) {
      resultMap[item.id].discount = discountPerUnit * discountQuantity
      resultMap[item.id].saleProgram = PROMOTION_NAME
    }

    remainingDiscountQuantity -= discountQuantity
  })
}
